module.exports = __webpack_public_path__ + "static/media/sale.4bca87cc.svg";